module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/2lBcLwdbh67xEdmI30CzBO-dd21c79abf15bbbc4e246091cf5a24af.jpg";